var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.5C7.72386 3.5 7.5 3.72386 7.5 4V7.5H4C3.72386 7.5 3.5 7.72386 3.5 8V20C3.5 20.2761 3.72386 20.5 4 20.5H16C16.2761 20.5 16.5 20.2761 16.5 20V16.5H20C20.2761 16.5 20.5 16.2761 20.5 16V4C20.5 3.72386 20.2761 3.5 20 3.5H8ZM16.5 15.5H19.5V4.5H8.5V7.5H16C16.2761 7.5 16.5 7.72386 16.5 8V15.5ZM4.5 19.5V8.5H15.5V19.5H4.5Z",
    fill: "#4D4E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6e8596f9d5a6bb2f6b91f0178befebef.svg";
export { ForwardRef as ReactComponent };